import { AutoFocus, Flex, Spacer, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Fragment, ReactNode } from 'react';

interface Props {
	title: ReactNode;
	titleSize?: 'large' | 'small';
	description?: ReactNode | { __html: string };
	noFocus?: boolean;
}

export function Title({ title, titleSize = 'large', description, noFocus }: Props) {
	const AutoFocusComp = noFocus ? Fragment : AutoFocus;

	return (
		<Flex direction='column'>
			<AutoFocusComp>
				<Text.h1 variant={titleSize === 'large' ? 'headingLarge' : 'headingSmall'}>{title}</Text.h1>
			</AutoFocusComp>

			{description ? (
				<>
					<Spacer vertical={tokens.spacing.x1} />
					{typeof description === 'object' && description != null && '__html' in description ? (
						<Text.p variant='bodyRegular' dangerouslySetInnerHTML={description}>
							{null}
						</Text.p>
					) : (
						<Text.p variant='bodyRegular'>{(description as string) != null ? (description as string) : ''}</Text.p>
					)}
				</>
			) : null}
		</Flex>
	);
}
